import { ActorConnectionPointType } from "../utils/io/connections/Actor";
import { ParamlessTypedActorNode } from "./_Base";
const OUTPUT_NAME = "val";
export var TwoWaySwitchActorNodeInputName = /* @__PURE__ */ ((TwoWaySwitchActorNodeInputName2) => {
  TwoWaySwitchActorNodeInputName2["CONDITION"] = "condition";
  TwoWaySwitchActorNodeInputName2["IF_TRUE"] = "ifTrue";
  TwoWaySwitchActorNodeInputName2["IF_FALSE"] = "ifFalse";
  return TwoWaySwitchActorNodeInputName2;
})(TwoWaySwitchActorNodeInputName || {});
const InputNames = [
  "condition" /* CONDITION */,
  "ifTrue" /* IF_TRUE */,
  "ifFalse" /* IF_FALSE */
];
export class TwoWaySwitchActorNode extends ParamlessTypedActorNode {
  static type() {
    return "twoWaySwitch";
  }
  initializeNode() {
    super.initializeNode();
    this.io.connection_points.initializeNode();
    this.io.connection_points.set_expected_input_types_function(this._expectedInputTypes.bind(this));
    this.io.connection_points.set_expected_output_types_function(this._expectedOutputTypes.bind(this));
    this.io.connection_points.set_input_name_function(this._expectedInputName.bind(this));
    this.io.connection_points.set_output_name_function(this._expectedOutputName.bind(this));
  }
  _expectedInputName(index) {
    return InputNames[index];
  }
  _expectedOutputName() {
    return OUTPUT_NAME;
  }
  _expectedInputTypes() {
    const second_or_third_connection = this.io.connections.inputConnection(1) || this.io.connections.inputConnection(2);
    const type = second_or_third_connection ? second_or_third_connection.src_connection_point().type() : ActorConnectionPointType.FLOAT;
    return [ActorConnectionPointType.BOOLEAN, type, type];
  }
  _expectedOutputTypes() {
    const type = this._expectedInputTypes()[1];
    return [type];
  }
  outputValue(context) {
    const condition = this._inputValue("condition" /* CONDITION */, context);
    if (condition) {
      return this._inputValue("ifTrue" /* IF_TRUE */, context) || 0;
    } else {
      return this._inputValue("ifFalse" /* IF_FALSE */, context) || 0;
    }
  }
}
